import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = ({ pageRange }) => {
    const height = 44 * (pageRange + 1)
    const body = new Array(pageRange + 1).fill(null).map((i, ind) => {
        let yStrip = ind ? (44 * ind + 8) : 12

        if (ind === 0) {
            yStrip = 12
        } else if (ind === 1) {
            yStrip = 50
        } else {
            yStrip = 44 * (ind - 1) + 50
        }

        return (
            <React.Fragment key={ind}>
                {
                    ind ?
                        <>
                            <rect x='15' y={yStrip} rx='3' ry='3' width='14' height='14' />
                            <rect x='37' y={yStrip + 1} rx='3' ry='3' width='110' height='12' />
                            <rect x='168' y={yStrip + 1} rx='3' ry='3' width='170' height='12' />
                            <rect x='393' y={yStrip + 1} rx='3' ry='3' width='80' height='12' />
                            <rect x='523' y={yStrip + 1} rx='3' ry='3' width='80' height='12' />
                            <rect x='653' y={yStrip} rx='3' ry='3' width='120' height='12' />
                            <rect x='803' y={yStrip} rx='3' ry='3' width='18' height='18' />
                        </> :
                        <>
                            <rect x='15' y={yStrip} rx='3' ry='3' width='14' height='14' />
                            <rect x='37' y={yStrip + 1} rx='3' ry='3' width='110' height='12' />
                            <rect x='168' y={yStrip + 1} rx='3' ry='3' width='65' height='12' />
                            <rect x='393' y={yStrip + 1} rx='3' ry='3' width='105' height='12' />
                            <rect x='523' y={yStrip + 1} rx='3' ry='3' width='105' height='12' />
                            <rect x='653' y={yStrip + 1} rx='3' ry='3' width='55' height='12' />
                        </>
                }
            </React.Fragment>
        )
    })

    return (
        <ContentLoader
            speed={2}
            width={834}
            height={height}
            viewBox={`0 0 834 ${height}`}
            backgroundColor='#f3f3f3'
            foregroundColor='#ecebeb'
        >
            <>
                {body}
            </>
        </ContentLoader>
    )
}

export default Loader